module.exports = __webpack_public_path__ + "img/无等级@2x.34a9e19f.png";